import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dashoffset: 150;
  }
  50% {
    stroke-dashoffset: 50;
    transform: rotate(45deg);
  }
  100% {
    stroke-dashoffset: 150;
    transform: rotate(360deg);
  }
`;

interface SpinnerProps {
  size: number;
}

const StyledSpinner = styled.svg<SpinnerProps>`
  animation: ${rotate} 2s linear infinite;
  width: ${(props) => props.size}rem;
  height: ${(props) => props.size}rem;
`;

const SpinnerCircle = styled.circle`
  stroke-dasharray: 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  fill: transparent;
  stroke: currentColor;
  stroke-linecap: round;
  transform-origin: center;
  animation: ${dash} 1.5s ease-in-out infinite;
`;

interface LoaderProps {
  size?: number;
}

export const Spinner: React.FC<LoaderProps> = ({ size = 1 }) => (
  <StyledSpinner viewBox="0 0 50 50" size={size}>
    <SpinnerCircle className="path" cx="25" cy="25" r="20" />
  </StyledSpinner>
);
